export { NileTabPanel } from './nile-tab-panel';
